import PropTypes from 'prop-types'

const optionShape = PropTypes.shape({
  label: PropTypes.string
})

const subGroupOptionShape = PropTypes.shape({
  label: PropTypes.string,
  items: PropTypes.arrayOf(optionShape)
})
export const groupOptionsShape = PropTypes.shape({
  label: PropTypes.string,
  items: PropTypes.arrayOf(subGroupOptionShape)
})

const colorsShape = PropTypes.shape({
  exterior: PropTypes.shape(),
  interior: PropTypes.shape()
})

const historicalShape = PropTypes.shape({
  firstHand: PropTypes.number,
  imported: PropTypes.number,
  maintains: PropTypes.number
})

const vehicleShape = PropTypes.shape({
  urlImage: PropTypes.string,
  dateOfRegistration: PropTypes.oneOfType([PropTypes.shape(), PropTypes.string]),
  brand: PropTypes.string,
  registrationPlate: PropTypes.string,
  modelGroup: PropTypes.string,
  model: PropTypes.string,
  finishes: PropTypes.string,
  colors: colorsShape,
  energy: PropTypes.string,
  options: PropTypes.arrayOf(optionShape),
  body: PropTypes.string,
  power: PropTypes.number,
  taxPower: PropTypes.number,
  kilowatt: PropTypes.any,
  gearBoxType: PropTypes.string,
  doors: PropTypes.number,
  mileage: PropTypes.number,
  tiresStateFront: PropTypes.number,
  tiresStateBack: PropTypes.number,
  historical: historicalShape,
  trailerHitch: PropTypes.number
})

const pointOfSalesShape = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  adress1: PropTypes.string,
  adress2: PropTypes.string,
  adress3: PropTypes.string,
  zipCode: PropTypes.string,
  city: PropTypes.string,
  email: PropTypes.string,
  phone1: PropTypes.string,
  phone2: PropTypes.string,
  lat: PropTypes.number,
  lng: PropTypes.number,
  entityName: PropTypes.string,
  DPOName1: PropTypes.string,
  DPOName2: PropTypes.string,
  DPOEmail: PropTypes.string
})

const userShape = PropTypes.shape({
  civility: PropTypes.number,
  lastName: PropTypes.string,
  firstName: PropTypes.string,
  email: PropTypes.string,
  zipCode: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  phoneNumber: PropTypes.string,
  marketingConsent: PropTypes.number,
  thirdConsent: PropTypes.number
})

const colorExteriorShape = PropTypes.shape()

const colorInteriorShape = PropTypes.shape()

const colorsListShape = PropTypes.shape({
  exterior: PropTypes.arrayOf(colorExteriorShape),
  interior: PropTypes.arrayOf(colorInteriorShape)
})

const designInteriorLeatherShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  serial: PropTypes.bool.isRequired
})

const designInteriorFabricShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  serial: PropTypes.bool.isRequired
})

const designExteriorTypeShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  type: PropTypes.number,
  price: PropTypes.number.isRequired
})

export const designListShape = PropTypes.shape({
  exterior: PropTypes.shape({
    type: PropTypes.arrayOf(designExteriorTypeShape)
  }),
  interior: PropTypes.shape({
    leathers: PropTypes.arrayOf(designInteriorLeatherShape),
    fabrics: PropTypes.arrayOf(designInteriorFabricShape)
  })
})

const futherInformationsShape = PropTypes.shape({
  funding: PropTypes.string,
  purchase: PropTypes.shape()
})

const tradeInPriceShape = PropTypes.shape({
  amount: PropTypes.number,
  expirationDate: PropTypes.string
})

export const filtersListShape = PropTypes.shape({
  yearsList: PropTypes.arrayOf(PropTypes.number),
  monthsList: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.string.isRequired, value: PropTypes.shape().isRequired })
  ),
  designList: designListShape,
  brandsList: PropTypes.arrayOf(PropTypes.shape()),
  modelsList: PropTypes.arrayOf(PropTypes.shape()),
  energiesList: PropTypes.arrayOf(PropTypes.shape()),
  finishesList: PropTypes.arrayOf(PropTypes.shape()),
  optionsList: PropTypes.shape(),
  colorsList: colorsListShape,
  pointsOfSalesList: PropTypes.arrayOf(pointOfSalesShape),
  vehiclesList: PropTypes.arrayOf(vehicleShape)
})

export const tradeInShape = PropTypes.shape({
  filtersList: filtersListShape,
  vehicle: vehicleShape,
  pointOfSales: pointOfSalesShape,
  futherInformations: futherInformationsShape,
  user: userShape,
  tradeInprice: tradeInPriceShape
})

export const fileShape = PropTypes.shape({
  name: PropTypes.string,
  url: PropTypes.string
})
